import React from 'react';
import TransformSection from './common/transform-section';
import { registerInspector } from './inspector-registry';
import ColorField from './shared/color-field';
import InspectorRow from './shared/inspector-row';
import InspectorSection from './shared/inspector-section';
import NumberField from './shared/number-field';
import { useFabricProp } from './shared/use-fabric-prop';
import type { ObjectInspectorProps } from './types';

const RectInspector: React.FC<ObjectInspectorProps> = ({ object, editor }) => {
  const [fill, setFill] = useFabricProp<string>(object, 'fill', editor);
  const [stroke, setStroke] = useFabricProp<string>(object, 'stroke', editor);
  const [strokeWidth, setStrokeWidth] = useFabricProp<number>(object, 'strokeWidth', editor);
  const [rx, setRx] = useFabricProp<number>(object, 'rx', editor);
  const [ry, setRy] = useFabricProp<number>(object, 'ry', editor);
  const [opacity, setOpacity] = useFabricProp<number>(object, 'opacity', editor);

  return (
    <>
      <TransformSection object={object} editor={editor} />
      <InspectorSection title="Appearance">
        <InspectorRow label="Fill">
          <ColorField value={fill} onChange={setFill} />
        </InspectorRow>
        <InspectorRow label="Stroke">
          <ColorField value={stroke} onChange={setStroke} />
        </InspectorRow>
        <InspectorRow label="Stroke W">
          <NumberField value={strokeWidth} onChange={setStrokeWidth} min={0} />
        </InspectorRow>
        <InspectorRow label="Opacity">
          <NumberField value={opacity} onChange={setOpacity} step={0.05} min={0} max={1} />
        </InspectorRow>
      </InspectorSection>
      <InspectorSection title="Corner Radius">
        <InspectorRow label="rx">
          <NumberField value={rx} onChange={setRx} min={0} />
        </InspectorRow>
        <InspectorRow label="ry">
          <NumberField value={ry} onChange={setRy} min={0} />
        </InspectorRow>
      </InspectorSection>
    </>
  );
};

export default RectInspector;

registerInspector('rect', RectInspector);
